import axiosInstance from 'src/lib/api-client/custom-axios';
import { QueryFunctionContext, useQuery, UseQueryOptions } from 'react-query';
import {
    testFailedSearchData,
    testSearchData,
    testSKUData,
} from 'src/components/BarcodeScanner/testData';
import { findItemsURL, getProductDetailsURL } from './urls';
import { FindItemsResponseProduct } from './types';

interface GetProductDetailsParams {
    productBarcode: string;
    zipCode: string;
    email: string;
    rewardsNumber: string;
    config?:
        | Omit<
              UseQueryOptions<
                  ProductDetailsResponse | null,
                  unknown,
                  ProductDetailsResponse | null,
                  any[]
              >,
              'queryKey' | 'queryFn'
          >
        | undefined;
}

export interface ProductDetailsResponse {
    name: string;
    description: string;
    rating: number;
    basePrice: number;
    finalPrice: number;
    imageURL: string;
    easyRewardsOffer: {
        headliner: string;
        message: string;
        offerId: number;
    } | null;
}
const GetProductDetailsKey = 'GetProductDetails';
async function getProductDetailsQueryFunc({
    queryKey,
}: QueryFunctionContext): Promise<ProductDetailsResponse> {
    try {
        const [, barcodeNumber, zipCode, email, rewardsNumber] = queryKey;
        // const productSearchResponse = testFailedSearchData;
        const productSearchResponse = (
            await axiosInstance.get(
                getProductDetailsURL.replace(
                    '{barcode_number}',
                    barcodeNumber as string
                )
            )
        ).data;
        const item = productSearchResponse.productTileData[0];
        if (item) {
            const itemSKU: string = item.itemId;
            // const skuLookupResponse = testSKUData;
            const skuLookupResponse = (
                await axiosInstance.post(findItemsURL, {
                    serviceContext: {
                        tenant: 'StaplesDotCom',
                        legacyTenant: '',
                        locale: 'en-US',
                        channelId: 'WEB',
                        siteId: 'US',
                        zipCode,
                        langId: '',
                        langCd: '',
                        storeId: '',
                        user: {
                            fingerprint: '',
                            emailHash: email,
                            directCustomerNumber: rewardsNumber,
                            customerNumber: '',
                            requestId: '',
                            userInfo: {},
                        },
                    },
                    skus: [itemSKU],
                })
            ).data;

            const productData: FindItemsResponseProduct | undefined =
                skuLookupResponse?.items[0];

            if (
                productData &&
                productData.product &&
                productData.product.upcCode === barcodeNumber
            ) {
                const splitTitle: string[] =
                    productData.product.name.split(',');
                const name = splitTitle.shift() as string;
                const description = splitTitle.join(', ');
                const { basePrice, finalPrice } =
                    productData.price.item[0].priceInfo[0];
                const rewards: ProductDetailsResponse['easyRewardsOffer'] =
                    null;
                // if (productData.price.item[0]?.easyrewards) {
                //     rewards = (productData.price.item[0].easyrewards
                //         .sort(
                //             (
                //                 offer1: { ranking: number },
                //                 offer2: { ranking: number }
                //             ) => offer1.ranking - offer2.ranking
                //         )
                //         .shift() ||
                //         null) as ProductDetailsResponse['easyRewardsOffer'];
                // }
                return {
                    name,
                    description,
                    rating: productData.product.review.rating,
                    basePrice,
                    finalPrice,
                    imageURL: productData.product.images.standard[0],
                    easyRewardsOffer: rewards,
                };
            }
        }
        throw new Error('Product not found');
    } catch (err) {
        console.error('Error in fetching product details', err);
        throw err;
    }
}
export function getProductDetailsQuery({
    productBarcode,
    zipCode,
    email,
    rewardsNumber,
    config,
}: GetProductDetailsParams) {
    return useQuery(
        [GetProductDetailsKey, productBarcode, zipCode, email, rewardsNumber],
        getProductDetailsQueryFunc,
        config
    );
}
